// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronUpSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8 7.05002L13 11.15V8.95002L8.9 5.65002L8 4.85002L7.1 5.65002L3 8.85002V11.05L8 7.05002Z" />
    </svg>
  );
};
